<template>
  <div>
  <special-index v-show="special && special['index/index']" :page-path="'index/index'" :item-id="''"></special-index>
  <div class="container" v-show="!special || !special['index/index']">
    <home-common-search :from='"home"'></home-common-search>
    <index-banner v-if="banners && banners.length > 0" :items="banners"></index-banner>
    <index-menu  :items="navs"></index-menu>
    <index-article class="mb-5" :items="articles"></index-article>
    <index-floor-ads v-if="floorAds" :ad="floorAds[0]"></index-floor-ads>
    <index-three-ads :items="promotionAds"></index-three-ads>
    <index-product-list
            :items="goodProducts"
            title="热门推荐"
            :type="popular"
            v-if="goodProducts && goodProducts.length > 0"
    ></index-product-list>
    <index-product-list
            :items="hotProducts"
            title="销量排行"
            :type="sale"
            v-if="hotProducts && hotProducts.length > 0"
    ></index-product-list>
    <index-floor-ads v-if="floorAds" :ad="floorAds[1]"></index-floor-ads>
    <index-product-list
            :items="recentlyProducts"
            title="新品上架"
            :type="recently"
            v-if="recentlyProducts && recentlyProducts.length > 0"
    ></index-product-list>
    <!-- 版权信息 -->
    <div class="copyright">
        <div class="app_download">
          <ul>
            <li v-if="!uniapp && isAndroid">
              <a href="https://cn.oubv.com/home/Download/?url=comoubvcnwholesale.apk">
                <img src="https://en.oubv.com/static/home/images/app_download.png">
              </a>
            </li>
          </ul>
        </div>
        <div v-if="config"><a href="http://www.beian.gov.cn/portal/registerSystemInfo" target="_blank">{{config.wab_number}}</a></div>
        <div v-if="config"><a href="https://beian.miit.gov.cn" target="_blank">{{config.icp_number}}</a></div>
        <div v-if="config">{{config.flow_static_code}}</div>
    </div>
  </div>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import { Toast } from 'mint-ui'
import SpecialIndex from '../special/Index'
import IndexProductList from './IndexProductList'
import HomeCommonSearch from '../common/HomeCommonSearch'
import IndexBanner from './IndexBanner'
import IndexMenu from './IndexMenu'
import IndexFloorAds from './IndexFloorAds'
import IndexThreeAds from './IndexThreeAds'
import IndexArticle from './IndexArticle'
import {loadScript} from "../../../util/common";
export default {
  name: 'HomeIndex',
  data () {
    return {
      uniapp: 0,
      isIos: false,
      isAndroid: false,
      isshowBacktop: true,
      popular: '',
      sale: 'goods_salenum',
      recently: 'goods_addtime'
    }
  },
  components: {
    SpecialIndex,
    IndexProductList,
    HomeCommonSearch,
    IndexBanner,
    IndexMenu,
    IndexFloorAds,
    IndexThreeAds,
    IndexArticle
  },
  mounted () {
  },
  created: function () {

    var u = navigator.userAgent;
    var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1;
    var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    if (isAndroid) {
      this.isAndroid = true;
    }
    if (isIOS) {
      this.isIOS = true;
    }

    let _this = this
    loadScript('uniapp', 'https://js.cdn.aliyun.dcloud.net.cn/dev/uni-app/uni.webview.1.5.2.js', function () {
      uni.getEnv(function (res) {
        _this.ifLoaded = true
        if (res.plus) {
          _this.uniapp = 1
        }
      })
    })

    this.fetchHomeAd({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeArticle({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchHomeProduct({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
    this.fetchConfig({}).then(
      response => {
      },
      error => {
        Toast(error.message)
      }
    )
  },
  computed: {
    ...mapState({
      special: state => state.home.special,
      config: state => state.config.config,
      banners: state => state.home.banners,
      navs: state => state.home.navs,
      floorAds: state => state.home.floorAds,
      promotionAds: state => state.home.promotionAds,
      articles: state => state.home.articles,
      hotProducts: state => state.home.hotProducts,
      recentlyProducts: state => state.home.recentlyProducts,
      goodProducts: state => state.home.goodProducts
    })
  },
  methods: {
    ...mapActions({
      fetchHomeAd: 'fetchHomeAd',
      fetchHomeArticle: 'fetchHomeArticle',
      fetchHomeProduct: 'fetchHomeProduct',
      fetchConfig: 'fetchConfig'
    })
  }
}
</script>
<style scoped>
.copyright{
  font-size:.65rem;
  color:#999;
  text-align: center;
  padding:.2rem 0;
}
.app_download{
  border-bottom: 1px solid #e5e5e5;
  padding: 0 0.36rem 0.3rem;
  margin-bottom: 0.36rem;
}
.app_download ul{
  overflow: hidden;
}
.app_download ul li {
  float: left;
  text-align: center;
  width: 33.3333%;
}
.app_download ul li a {
  display: block;
  width: 100%;
  position: relative;
}
.app_download ul li img {
  width: 3rem;
  vertical-align: middle;
}
</style>